import { Text } from '@loadsmart/loadsmart-ui'

import { FooterItem } from './LoadSummary.styles'

type LoadSummaryMilesProps = {
  mileage: string
}

export function LoadSummaryMiles({ mileage }: LoadSummaryMilesProps) {
  return (
    <FooterItem>
      <Text as="div" variant="caption-bold" color="color-neutral-dark">
        Miles
      </Text>
      <Text as="div" variant="body">
        {mileage}
      </Text>
    </FooterItem>
  )
}
